import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Criteria } from '@sc/data-access-models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdministrationHttpService {
  private readonly saveCriteriasUrl = '/api/preferences/criterias/save';
  private readonly listCriteriasUrl = '/api/preferences/criterias/list';

  constructor(private readonly httpClient: HttpClient) {}

  saveCriterias(criterias: Criteria[]): Observable<Criteria[]> {
    return this.httpClient.post<Criteria[]>(
      this.saveCriteriasUrl,
      { criterias },
      {
        headers: { requestName: 'administration-http saveCriterias' },
      }
    );
  }

  listCriterias(): Observable<Criteria[]> {
    return this.httpClient.get<Criteria[]>(this.listCriteriasUrl, {
      headers: {
        requestName: 'administration-http listCriterias',
      },
    });
  }
}
